import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { useSuperDuper } from '../context/SuperDuperContext';

const DeleteQuizDialog = () => {
  const { deleteDialogOpen, quizToDelete, confirmDeleteQuiz, cancelDeleteQuiz } = useSuperDuper();

  return (
    <Dialog
      open={deleteDialogOpen}
      onClose={cancelDeleteQuiz}
      aria-labelledby="delete-quiz-dialog-title"
    >
      <DialogTitle id="delete-quiz-dialog-title">
        Confirm Delete Quiz
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the quiz "{quizToDelete?.name}"? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelDeleteQuiz} color="primary">
          Cancel
        </Button>
        <Button onClick={confirmDeleteQuiz} color="error" variant="contained" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteQuizDialog;
